export default __webpack_public_path__ + "static/media/trias_grant.36c5d9f2.png";